module.exports = __webpack_public_path__ + "img/11.97931f46.jpg";